export const parseInputMask = (value: string) => {
  return value.replace(/\)/g, "").replace(/\(/g, "").replace(/-/g, "").replace(/ /g, "");
};

export const parseDateInputMask = (value: string) => {
  return value.replaceAll(/[._\s]/g, "");
};
